import { Box, Popper, PopperProps, autocompleteClasses } from '@mui/material'
import clsx from 'clsx'
import { tss } from 'tss-react/mui'

/**
 * Shows a custom popper for showing the search results in the search bar
 */
export function SearchResultsPopper(props: PopperProps) {
  const { classes } = useStyles(props)
  return (
    <Popper
      {...props}
      component={({ className, style, ...props }) => {
        return (
          <Box
            className={clsx(classes.root, className)}
            data-testid="doss-search-popper-root"
            {...props}
            style={{
              ...style,
              width: '100%',
            }}
          />
        )
      }}
    ></Popper>
  )
}

const useStyles = tss.create(({ theme }) => ({
  root: {
    overflowY: 'auto',
    width: '100%',
    height: '95%',
    [`& .${autocompleteClasses.paper}`]: {
      height: '100%',
      boxShadow: 'none',
    },
    [`& .${autocompleteClasses.noOptions}`]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: 'none',
      height: '100%',
      fontSize: theme.typography.heading3.fontSize,
    },
    [`& .${autocompleteClasses.listbox}`]: {
      backgroundColor: theme.palette.common.doss.white,
      maxHeight: 'none',
      maxWidth: 'none',
      height: '100%',
      borderRadius: '4px',
      paddingBlock: theme.spacing(0),
      paddingInline: theme.spacing(0.25),
      [`& .${autocompleteClasses.option}`]: {
        padding: theme.spacing(0.75),
        marginBlock: theme.spacing(0.5),
        marginInline: theme.spacing(0),
        [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]:
          {
            backgroundColor: theme.palette.common.doss.gray[2],
            borderRadius: '4px',
            ['.searchEnter']: {
              display: 'inline-flex',
            },
          },
      },
    },
  },
}))
